import React from 'react';
import { Grid, TextField, Typography, CardContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SimpleMenu, MenuWithId } from 'components';
import { useEvents } from 'hooks';

const HarvestFieldInput = () => {
  const { t } = useTranslation();

  // temporary hard coded types of harvest
  const harvestTypes = [
    { name: t('forage'), id: 'forage' },
    { name: t('grain'), id: 'grain' },
  ];

  const { setPlan, farmerPlan } = useEvents();

  const handleHarvestMethodChange = (method) => {
    setPlan({
      data: { ...farmerPlan.data, harvest_method: method.id },
    });
  };

  const handleYieldAmountChange = (event) => {
    setPlan({
      data: { ...farmerPlan.data, yield: event.target.value },
    });
  };

  const handleYieldUnitsChange = (units) => {
    setPlan({
      data: { ...farmerPlan.data, yield_units: units },
    });
  };

  return (
    <div>
      <CardContent>
        <Typography variant="h6">{t('harvest_information')}</Typography>
      </CardContent>
      <Grid container>
        <Grid item xs={12} sm={4} padding={2} alignItems="center">
          <Typography variant="subtitle2" gutterBottom component="div">
            {t('select_harvest')}
          </Typography>
          <MenuWithId
            placeholder={t('harvest_method')}
            menuItems={harvestTypes}
            selectedItem={t(farmerPlan?.data?.harvest_method)}
            selectItem={handleHarvestMethodChange}
            diabled={!harvestTypes || harvestTypes.length === 0}
            size="normal"
          />
        </Grid>
        <Grid item container direction="row" alignItems="center" xs={12} sm={8} padding={2}>
          <Grid item sm={6}>
            <TextField
              id="yield"
              label={t('yield')}
              value={farmerPlan?.data?.yield}
              placeholder="0"
              onChange={handleYieldAmountChange}
              type="number"
            />
          </Grid>
          <Grid item sm={2}>
            <SimpleMenu
              placeholder={t('yield_units')}
              menuItems={['bushels', 'tons', 'lb/ac', 'kg']}
              selectedItem={farmerPlan?.data?.yield_units}
              selectItem={handleYieldUnitsChange}
              size="normal"
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default HarvestFieldInput;
